export default [
    {
        path: "/xhs/agent/dashboard",
        name: "xhs-dashboard",
        component: () => import("@/views/xhs/agent/dashboard.vue"),
    },
    {
        path: "/xhs/agent/generate",
        name: "xhs-generate",
        component: () => import("@/views/xhs/agent/generate.vue"),
    },
    {
        path: "/xhs/agent/history",
        name: "xhs-history",
        component: () => import("@/views/xhs/agent/history.vue"),
    },
    {
        path: "/xhs/strategy/proposal/list",
        name: "xhs-strategy-proposal-list",
        component: () => import("@/views/xhs/strategy/proposal/list.vue"),
    },
    {
        path: "/xhs/strategy/proposal/generate",
        name: "xhs-strategy-proposal-generate",
        component: () => import("@/views/xhs/strategy/proposal/generate.vue"),
    },
    {
        path: "/xhs/strategy/diagnose/list",
        name: "xhs-strategy-diagnose-list",
        component: () => import("@/views/xhs/strategy/diagnose/list.vue"),
    },
    {
        path: "/xhs/strategy/diagnose/generate",
        name: "xhs-strategy-diagnose-generate",
        component: () => import("@/views/xhs/strategy/diagnose/generate.vue"),
    }
]